import "./App.css";
import { Suspense } from "react";
import Loader from "./components/other/Loader";
import { AllRoutes } from "./routes/pageRoutes";
import PrivateRoute from "./layout/PrivateRoute";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {AllRoutes?.map((item, index) => {
          return (
            <Route
              key={index}
              exact
              path={item.path}
              element={
                item?.isPrivate ? (
                  <PrivateRoute>{item?.element}</PrivateRoute>
                ) : (
                  item?.element
                )
              }
            />
          );
        })}
        {/* <Route exact path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
}

export default App;
